import UnicomCode from '@/pages/UnicomCode'
import CardAd from '@/pages/CardAd'
import CardVipAd from '@/pages/CardVipAd'
import CardVipOnePage from '@/pages/CardVipOnePage'
import KerunAd from '@/pages/KerunAd'
import Collection from '@/pages/Collection'
import StrategyLand from '@/pages/StrategyLand'
import ValueEquityCard from '@/pages/NumberCardAd/ValueEquityCard'
import AllYearFreeCard from '@/pages/NumberCardAd/AllYearFreeCard'
import VipLandPage from '@/pages/VipLandPage'
import MeiZhuang from '@/pages/MeiZhuang'

const unicomRoute: IRouter[] = [
  {
    path: 'unicomCode',
    element: <UnicomCode />,
  },
  {
    path: 'cardAd',
    element: <CardAd />,
  },
  {
    path: 'cardVipAd',
    element: <CardVipAd />,
  },
  {
    path: 'cardVipOne',
    element: <CardVipOnePage />,
  },
  {
    path: 'krAd',
    element: <KerunAd />,
  },
  {
    path: 'strategy',
    element: <StrategyLand />,
  },
  {
    path: 'collection',
    element: <Collection />,
  },
  {
    path: 'vipLand',
    element: <VipLandPage />,
  },
  {
    path: 'numberCardAd/equitCard',
    element: <ValueEquityCard />,
  },
  {
    path: 'numberCardAd/yearCard',
    element: <AllYearFreeCard />,
  },
  {
    path: 'mzAd',
    element: <MeiZhuang />,
  },
]

export default unicomRoute
